<template>
  <div class="question">
    <h2 class="title">{{ question.title }}</h2>
    <div class="answers">
      <div class="answer-wrapper" :class="{ twoColumns: question.answers.length > 6 }">
        <div 
          class="answer" 
          v-for="answer in question.answers" 
          :key="answer.id"
          :class="{
            radio: question.questionType === 'Radio group',
            checkbox: question.questionType === 'Checkbox group',
            checked: isChecked(answer.id), 
          }"
        >
          <input
            :type="question.questionType === 'Radio group' ? 'radio' : 'checkbox'"
            :name="question.id"
            :id="answer.id"
            :value="answer.id"
            v-model="selectedAnswers"
          /><label :for="answer.id">{{ answer.title }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, PropType, defineProps, defineEmits } from "vue";
  import { Question } from "../models/Question";

  const { question } = defineProps({
    question: {
      type: Object as PropType<Question>,
      required: true,
    },
  });

  const emit = defineEmits(["selectedAnswers"]);

  const selectedAnswers = ref<number[]>([]);

  function isChecked(answerId: number) {
    emit("selectedAnswers", selectedAnswers.value);

    if (question.questionType === 'Radio group') {
      return selectedAnswers.value[0] === answerId;
    } else {
      return selectedAnswers.value.filter((a) => a === answerId).length > 0;
    }
  }
</script>
